// Shared social-proof math for the video courses.
//
// The API returns the true enrollment count per course (distinct CourseAccess
// rows). C# Foundation additionally carries a small hardcoded baseline that
// sits on top of that live number, so the stat keeps counting up as real
// buyers arrive instead of being a frozen fake figure. Every other course
// shows its real count untouched.
export const CSHARP_ENROLLED_BASELINE = 3;

// Baseline + realtime buyers for C#; the raw API count for everything else.
export const enrolledFor = (course) =>
  (course?.enrolledCount ?? 0) +
  (course?.product === "csharp" ? CSHARP_ENROLLED_BASELINE : 0);
